var PKIFreeText_1;
import { __decorate } from "tslib";
import { AsnArray, AsnProp, AsnPropTypes, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { PKIFailureInfo } from "./pki_failure_info";
import { PKIStatus } from "./pki_status";
let PKIFreeText = PKIFreeText_1 = class PKIFreeText extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, PKIFreeText_1.prototype);
    }
};
PKIFreeText = PKIFreeText_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.Utf8String })
], PKIFreeText);
export { PKIFreeText };
export class PKIStatusInfo {
    constructor(params = {}) {
        this.status = PKIStatus.granted;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], PKIStatusInfo.prototype, "status", void 0);
__decorate([
    AsnProp({ type: PKIFreeText, optional: true })
], PKIStatusInfo.prototype, "statusString", void 0);
__decorate([
    AsnProp({ type: PKIFailureInfo, optional: true })
], PKIStatusInfo.prototype, "failInfo", void 0);
